module.exports = "/packs/009-b5a6b4a74971464225aa2f05e0de2258.jpg";